import React from "react";
import { isNullOrEmpty } from "../helpers/string-helper";
export const Column = (props) => {
    let className = props.size > 0 ? `ms-Grid-col ms-sm${props.size} ms-md${props.size} ms-lg${props.size}` : `ms-Grid-col ms-sm${props.sm} ms-md${props.md} ms-lg${props.lg}`;
    if (!isNullOrEmpty(props.className)) {
        className += ' ' + props.className;
    }
    return React.createElement("div", { className: className, style: props.style }, props.children);
};
